import { MdHowToVote } from 'react-icons/md';
import { RoleNavbar } from 'src/layouts/dashboard/navbar/Navbar';
import { NavbarAdminMainButton } from 'src/layouts/dashboard/navbar/admin/NavbarAdminMainButton';
import { NavbarMemberMainButton } from 'src/layouts/dashboard/navbar/member/NavbarMemberMainButton';
import { PATH_OPINION } from 'src/routes/paths';

type Props = {
  role: RoleNavbar;
};

export const OpinionButton = ({ role }: Props) => (
  <a href={PATH_OPINION} target="_blank" rel="noopener noreferrer">
    {role === 'member' ? (
      <NavbarMemberMainButton startIcon={<MdHowToVote size={18} />} sx={{ width: '100%' }}>
        ご意見・ご要望
      </NavbarMemberMainButton>
    ) : (
      <NavbarAdminMainButton
        title="ご意見・ご要望"
        startIcon={<MdHowToVote size={18} />}
        sx={{
          width: '100%',
          padding: '5px 0px',
          '& .MuiButton-startIcon': {
            marginLeft: '12px',
            marginRight: '12px',
          },
        }}
      />
    )}
  </a>
);
